module.exports = __webpack_public_path__ + "img/Human_symbol_3.424428eb.png";